import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Router, NavigationEnd } from '@angular/router';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['../assets/lib/bootstrap/css/bootstrap.min.css']
})
export class AppComponent {
  title = 'Ivan Viladrich';
  defaultLang = "en";


  constructor(translate: TranslateService, private router: Router) {
    // this language will be used as a fallback when a translation isn't found in the current language
    translate.setDefaultLang(this.defaultLang);
    // the lang to use, if the lang isn't available, it will use the current loader to get them
    translate.use(this.defaultLang);

    //ca->català,en->english,es->español,en-US->english-US,en-GB->english-UK
    //console.log(navigator.language);

    //captures router events and informs Google Analytics
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        (<any>window).ga('set', 'page', event.urlAfterRedirects);
        (<any>window).ga('send', 'pageview');
      }
    });
  }
}
